module.exports = __webpack_public_path__ + "media/images/team__legionxiii-694be5eb1d2318f39859ac39a6b147f1.png";